module.exports = __webpack_public_path__ + "img/TvDip-Logo.10e4e1.svg";